
import React from 'react';

const EmptyProductsList = () => {
  return (
    <div className="text-center py-8 text-gray-500">
      Aucun produit ajouté à cette commande
    </div>
  );
};

export default EmptyProductsList;
